import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { workStateTitle, workStateIcon, serviceAuthConsts } from 'app/constants';
import { tech } from 'app/constants/permissions';
import { HelperService } from 'app/services';

@Component({
  selector: 'app-multi-tech-selection-row',
  templateUrl: './multi-tech-selection-row.component.html',
  styleUrls: ['./multi-tech-selection-row.component.scss'],
})
export class MultiTechSelectionRowComponent implements OnInit {
  @Input() technicians: any[] = [];
  @Input() service: any = {};
  @Input() errors: any = {};
  @Input() techInitials: any = {};
  @Input() isServiceAssignDisabled: boolean = false;
  @Input() currentLang: string = 'en';
  @Input('serviceTech')
  set serviceTech(serviceTech: any) {
    this.currentTech = serviceTech || {};

    this.handleDisableField();
  }

  @Output() appTechSelect = new EventEmitter();

  workStateIcon: any = {};
  workStateTitle: any = {};
  serviceAuthConsts: any = {};
  currentTech: any = {};
  _technicians: any[] = [];

  constructor(public helperService: HelperService) {}

  ngOnInit() {
    this.workStateIcon = workStateIcon;
    this.workStateTitle = workStateTitle;
    this.serviceAuthConsts = serviceAuthConsts;
    this.setTechnician(this.technicians);
    this.handleDisableField();
  }

  setTechnician(technicians: any[]) {
    this._technicians = technicians.map((technician: any) => {
      const data = { ...technician };
      const { tech = {}, hTechOne = {}, hTechTwo = {} } = this.service;
      const techWorkStatus = [];

      if (tech?.techId === technician?.techId) {
        techWorkStatus.push(tech.workStatus);
        data.workStatus = tech.workStatus;
        data.disabledTooltip = tech.workStatus === 'inprogress' ? `${this.techInitials[tech.techId].name || tech.name} is working on service and cannot be reassigned` : '';
      } else if (hTechOne?.techId === data?.techId) {
        techWorkStatus.push(hTechOne.workStatus);
        data.workStatus = hTechOne.workStatus;
        data.disabledTooltip = hTechOne.workStatus === 'inprogress' ? `${this.techInitials[hTechOne.techId].name || tech.name} is working on service and cannot be reassigned` : '';
      } else if (hTechTwo?.techId === data?.techId) {
        techWorkStatus.push(hTechTwo.workStatus);
        data.workStatus = hTechTwo.workStatus;
        data.disabledTooltip = hTechTwo.workStatus === 'inprogress' ? `${this.techInitials[hTechTwo.techId].name || tech.name} is working on service and cannot be reassigned` : '';
      }

      data.isActive = !techWorkStatus.includes('inprogress'); // Active technician for primary tech
      data.isActive1 = !techWorkStatus.includes('inprogress'); // Active technician for helper tech 1
      data.isActive2 = !techWorkStatus.includes('inprogress'); // Active technician for helper tech 2

      return data;
    });
  }

  handleTechSelect(key: string, tech: any) {
    this.appTechSelect.emit({ key, tech, serviceId: this.service._id });
  }

  handleDisableField() {
    if (!this.service) return;

    const { tech = {}, hTechOne = {}, hTechTwo = {} } = this.currentTech;

    this._technicians.forEach((technician) => {
      technician.isActive = true;
      technician.isActive1 = true;
      technician.isActive2 = true;

      if (tech.techId && technician.techId === tech.techId) {
        // This is only for primary technician
        tech.workStatus = tech.workStatus || this.service.status;

        if (tech.workStatus === 'inprogress') {
          technician.isActive = false;
          technician.isActive1 = false;
          technician.isActive2 = false;
        }
      }

      if (hTechOne.techId && technician.techId === hTechOne.techId) {
        if (hTechOne.workStatus === 'inprogress') {
          technician.isActive = false;
          technician.isActive1 = false;
          technician.isActive2 = false;
        }
      }

      if (hTechTwo.techId && technician.techId === hTechTwo.techId) {
        if (hTechTwo.workStatus === 'inprogress') {
          technician.isActive = false;
          technician.isActive1 = false;
          technician.isActive2 = false;
        }
      }
    });

    this._technicians = [...this._technicians];
  }
}
